// src/components/VideoCarousel.jsx
import React, { useEffect } from 'react';
import EmbedCard from './EmbedCard';
import './VideoCarousel.css'; // your existing styles

const videoUrls = [
  "https://www.instagram.com/reel/DBdfA-Mtypd/",
  "https://www.instagram.com/reel/DEhm-YiSrC8/", // replace with your real ones
  "https://www.instagram.com/reel/DDjxeGyvsOr/",
  "https://www.instagram.com/reel/DCy3hQRgqDA/",
  "https://www.instagram.com/reel/DCZHo22Sh57/",
  "https://www.instagram.com/reel/DCOrkVqAs-A/",
  "https://www.instagram.com/reel/DBtSEuRBjBv/",
  "https://www.instagram.com/reel/DA--C5YBN0o/",
 

];

const VideoCarousel = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//www.instagram.com/embed.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section className="carousel-section">
      <h2 className="carousel-title">Explore Our Instagram Reels</h2>
      <div className="video-carousel">
        {videoUrls.map((url, idx) => (
          <EmbedCard key={idx} url={url} />
        ))}
      </div>
    </section>
  );
};

export default VideoCarousel;
